import axios from "axios";
import React, { Component } from "react";
import ConstantUrl from "../util/ConstantUrl";
import { Parser } from "html-to-react";
import { Link } from "react-router-dom";
export default class ResearchArticles extends Component {
  constructor(props) {
    super(props);
    this.state = {
        articledata: [],
    };
    this.URL = new ConstantUrl();
  }



  async componentDidMount() {
    const URL = new ConstantUrl();

    await axios.post(URL.article).then((response) => {
      const articledata = response.data["data"];
     
      this.setState({ articledata });
    });
  }



  render() {
    return (
      <>
        {/* {{-- =============================================
                    BREADCRUMB
    ============================================  --}} */}
        <section id="breadcrumb">
          <div className="container-fluid">
            <div className="container">
              <div className="breadcrumb-bar">
                <div>
                  <Link to="/home">Home</Link>
                </div>
                <div>
                  &nbsp; <i className="fa-solid fa-minus"></i> &nbsp;
                </div>
                <div>Research Articles</div>
              </div>
            </div>
          </div>
          <hr className="m-0" />
        </section>

        {/* {{-- =============================================
                    REMEDIES AREA
    ============================================  --}} */}
        <section id="remedies-area">
          <div className="section-gap">
            <div className="container-fluid">
              <div className="container">
                <div className="remedies-grid">
                  <div className="row">
                    {this.state.articledata.map((articlealldata) => (
                    
                      <div className="col-lg-3 col-md-4 col-sm-6">
                       
                        <Link to={`/researchArticlesDetails/${articlealldata.id}`}>
                          <div className="remedy-card">
                            <div className="remedy-img">
                              <img
                                src={articlealldata.image1}
                                alt="..."
                                className="w-100 h-100"
                              />
                            </div>
                            <div className="remedy-content">
                              <div className="remedy-head text-truncate">
                                {articlealldata.title}
                              </div>
                              <div className="remedy-data">
                                {Parser().parse(articlealldata.details)}
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
